import { useNavigate } from '@tanstack/react-router'
import { useDevicePushSubscribed, type PushDeviceScope } from '../features/live/pushQueries'
import { useLiveAlerts, type LiveAlerts } from '../features/live/useLiveAlerts'
import { useSession } from '../session/useSession'

export type ShellLiveAlerts = LiveAlerts & { openItem: (conversationId: string) => void }

const pushScopeOf = (session: ReturnType<typeof useSession>): PushDeviceScope | null =>
  session.status === 'ready' ? { userId: session.me.user.id, tenantId: session.membership.tenantId } : null

export const useShellLiveAlerts = (): ShellLiveAlerts => {
  const navigate = useNavigate()
  const openItem = (itemId: string) => void navigate({ to: '/items/$itemId', params: { itemId } })
  const session = useSession()
  const scope = pushScopeOf(session)
  const pushHandlesDesktop = useDevicePushSubscribed(scope).data === true
  return { ...useLiveAlerts({ openItem, pushHandlesDesktop }), openItem }
}
